import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/storage';
import 'firebase/compat/database';
import 'firebase/compat/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA_qUc0ZDqQImE8PLL0aM4m-k9v6LhQQyo",
  authDomain: "velmar-9743b.firebaseapp.com",
  projectId: "velmar-9743b",
  storageBucket: "velmar-9743b.appspot.com",
  messagingSenderId: "911760127240",
  appId: "1:911760127240:web:248f9576b00a860898e8bd",
  measurementId: "G-QT3EQJR2GB"
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const storage = firebase.storage();
export const database = firebase.database();
export const firestore = firebase.firestore();